import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { IfLoadedModule } from 'src/app/shared/directives/if-loaded/if-loaded.module'
import { ContainerModule } from '../../container/container.module'
import { HeaderModule } from '../../header/header.module'
import { LazyLoadModule } from 'lazy-load'
import { EntityHubLayoutComponent } from './entity-hub-layout.component'
import { MapPipeModule } from '../../map-pipe/map-pipe.module'
import { NavModule } from '../../navigation/nav.module'
import { BannerCalloutModule } from '../../banner-callout/banner-callout.module'
import { ContentRightRailLayoutModule } from '../content-right-rail-layout/content-right-rail-layout.module'

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    LazyLoadModule,
    HeaderModule,
    ContainerModule,
    IfLoadedModule,
    MapPipeModule,
    NavModule,
    BannerCalloutModule,
    ContentRightRailLayoutModule
  ],
  declarations: [EntityHubLayoutComponent],
  exports: [EntityHubLayoutComponent]
})
export class EntityHubLayoutModule {}
